import { FalFundAllocation, getAssetColor } from "../../utils/falFunds";

const SIZE = 111;
const STROKE = 11;
const GAP = 3;
const RADIUS = (SIZE - STROKE) / 2;
const CIRCUMFERENCE = 2 * Math.PI * RADIUS;

interface Props {
  allocation: FalFundAllocation[];
}

const FalFundDonut = ({ allocation }: Props) => {
  let offset = 0;

  return (
    <svg
      width={SIZE}
      height={SIZE}
      viewBox={`0 0 ${SIZE} ${SIZE}`}
      aria-hidden="true"
    >
      <g transform={`rotate(-90 ${SIZE / 2} ${SIZE / 2})`}>
        {allocation.map(({ activo, pct }, index) => {
          const length = (pct / 100) * CIRCUMFERENCE;
          const segment = (
            <circle
              key={activo}
              cx={SIZE / 2}
              cy={SIZE / 2}
              r={RADIUS}
              fill="none"
              stroke={getAssetColor(activo, index)}
              strokeWidth={STROKE}
              strokeDasharray={`${length - GAP} ${CIRCUMFERENCE - length + GAP}`}
              strokeDashoffset={-offset}
            />
          );
          offset += length;
          return segment;
        })}
      </g>
    </svg>
  );
};

export default FalFundDonut;
